export default __webpack_public_path__ + "static/media/quick-invest-icon.ce0c84d0.svg";